import { Injectable } from "@angular/core";
import { StatusSeverity } from "@nms-angular-toolkit/nms-diagram-card";

/**
 * Serviço responsável por prover métodos auxiliares para a montagem dos dados do popover
 */
@Injectable({
    providedIn: "root"
})
export class PopoverHelperService {

    /**
     * Normaliza o status de modo a ficarem coerentes com os valores existentes em StatusSeverity do NmsDiagramCard.
     * Em alguns casos o status pode assumir o valor no formato STATUS_FAULT (ex: status de links), neste caso a normalização
     * remove o sufixo _FAULT e transforma o restante da string em minúsculo, respeitando os valores de StatusSeverity.
     */
    public normalizeCardSeverity(severity): StatusSeverity {
        return severity.toString().replace(/_FAULT$/, "").toLocaleLowerCase() as StatusSeverity;
    }

    /**
     * Adiciona um sufixo ao textSource caso ela exista.
     * Se o valor de textSource for nulo, o retorno será "N/A".
     */
    public getTextOrPlaceHolder(textSource: string | number, suffix?: string): string {
        return textSource ? `${textSource} ${suffix || ""}`.trim() : "N/A";
    }

}
